/* CHICHICAS: one positive phrase per day, same date for all visitors in Spain. */
(() => {
  const DAY_MS = 86400000;
  function dayOfYearInSpain(date) {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Madrid',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    });
    const parts = Object.fromEntries(
      formatter.formatToParts(date).map((part) => [part.type, part.value])
    );
    const year = Number(parts.year);
    const month = Number(parts.month);
    const day = Number(parts.day);
    return Math.floor((Date.UTC(year, month - 1, day) - Date.UTC(year, 0, 1)) / DAY_MS);
  }

  function render() {
    document.querySelectorAll('[data-ch-daily-affirmations]').forEach((bar) => {
      const phrases = (bar.dataset.chQuotes || '').split('|').filter(Boolean);
      const target = bar.querySelector('[data-ch-daily-text]');
      if (!target || !phrases.length) return;
      const index = dayOfYearInSpain(new Date()) % phrases.length;
      const next = phrases[index];
      if (target.textContent !== next) target.textContent = next;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render, { once: true });
  } else {
    render();
  }
  document.addEventListener('shopify:section:load', render);
  // One-time calculation on page load; updates on the next page visit or refresh.
})();
